import { useCallback, useEffect, useRef, useState } from "react";

const VERSION_CHECK_INTERVAL = 60_000;

export function useVersionCheck() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const checkVersion = useCallback(async () => {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`);
      if (!response.ok) return;
      const data = await response.json();
      if (data.version && data.version !== __APP_VERSION__) {
        setNewVersionAvailable(true);
      }
    } catch {
      // ignore - version.json may not exist in dev
    }
  }, []);

  useEffect(() => {
    if (import.meta.env.DEV) return;

    const scheduleCheck = () => {
      timerRef.current = setTimeout(async () => {
        await checkVersion();
        scheduleCheck();
      }, VERSION_CHECK_INTERVAL);
    };

    scheduleCheck();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") checkVersion();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimeout(timerRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [checkVersion]);

  const reload = useCallback(() => window.location.reload(), []);

  return { newVersionAvailable, reload };
}
